import React from 'react';
import { Shield, Zap, RotateCcw, Smartphone } from 'lucide-react';
export function HeroSection() {
  const scrollToOrder = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const orderSection = document.getElementById('order');
    if (orderSection) {
      orderSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy px-5 pb-[60px] pt-20" data-id="element-201">
      {/* Background gradients */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(0,255,65,0.08)_0%,transparent_60%),radial-gradient(ellipse_at_bottom_left,rgba(0,255,65,0.05)_0%,transparent_60%)] pointer-events-none" data-id="element-202" />
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,255,65,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,255,65,0.03)_1px,transparent_1px)] bg-[size:50px_50px] pointer-events-none" data-id="element-203" />

      <div className="relative z-10 mx-auto grid w-full max-w-[1100px] grid-cols-1 items-center gap-[60px] md:grid-cols-2" data-id="element-204">
        <div className="text-center md:text-left" data-id="element-205">
          <div className="mb-5 inline-block rounded-full border border-neon/30 bg-neon/10 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[2px] text-neon" data-id="element-206">
            🧬 MINIMALIST BIOHACKING PROTOCOL — 2026
          </div>

          <div className="mb-6 flex flex-wrap items-center justify-center gap-3 md:justify-start" data-id="element-207">
            <div className="flex" data-id="element-208">
              {['👨', '👩', '👨🏽', '👩🏻', '👨🏾'].map((emoji, i) => <div key={i} className={`flex h-8 w-8 items-center justify-center rounded-full border-2 border-navy bg-card text-base ${i !== 0 ? '-ml-2' : ''}`} data-id="element-209">
                  {emoji}
                </div>)}
            </div>
            <div className="text-[13px] text-coolgray" data-id="element-210">
              <span className="text-sm text-gold" data-id="element-211">★★★★★</span> Trusted by{' '}
              <strong className="text-neon" data-id="element-212">4,200+ professionals</strong> across
              the US
            </div>
          </div>

          <h1 className="mb-5 text-[clamp(30px,4.5vw,54px)] font-black leading-[1.1] tracking-[-1px] text-offwhite" data-id="element-213">
            How to <span className="text-neon" data-id="element-214">Delete Brain Fog</span> in 15
            Minutes and Reclaim 4 Hours of Peak Productivity Every Day
          </h1>

          <p className="mb-[30px] text-[17px] leading-[1.7] text-coolgray" data-id="element-215">
            The World-First Minimalist Biohacking System for High-Performance
            Professionals tired of feeling like a zombie by 3:00 PM.{' '}
            <strong className="text-offwhite" data-id="element-216">
              No expensive supplements. No 2-hour routines. No biology degree
              required.
            </strong>
          </p>

          <a href="#order" onClick={scrollToOrder} className="block w-full rounded-lg bg-gradient-to-br from-neon to-neon-dark px-9 py-5 text-center text-[17px] font-black text-black no-underline transition-all duration-300 hover:-translate-y-0.5 animate-pulse-glow" data-id="element-217">
            ⚡ GET THE COMPLETE PROTOCOL — ONLY $6.97
          </a>

          <p className="mt-2.5 text-center font-mono text-xs text-coolgray" data-id="element-218">
            ✅ Instant Access &nbsp;|&nbsp; 🔒 Secure Checkout &nbsp;|&nbsp;
            7-Day Guarantee
          </p>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-4 md:justify-start" data-id="element-219">
            <div className="flex items-center gap-1.5 text-xs text-coolgray" data-id="element-220">
              <Shield className="h-4 w-4 text-neon" data-id="element-221" />
              <span data-id="element-222">256-bit SSL</span>
            </div>
            <div className="flex items-center gap-1.5 text-xs text-coolgray" data-id="element-223">
              <Zap className="h-4 w-4 text-neon" data-id="element-224" />
              <span data-id="element-225">Instant Digital Access</span>
            </div>
            <div className="flex items-center gap-1.5 text-xs text-coolgray" data-id="element-226">
              <RotateCcw className="h-4 w-4 text-neon" data-id="element-227" />
              <span data-id="element-228">7-Day Money Back</span>
            </div>
            <div className="flex items-center gap-1.5 text-xs text-coolgray" data-id="element-229">
              <Smartphone className="h-4 w-4 text-neon" data-id="element-230" />
              <span data-id="element-231">Read on Any Device</span>
            </div>
          </div>
        </div>

        <div className="order-first md:order-last" data-id="element-232">
          <div className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-3 rounded-2xl border border-neon/20 bg-gradient-to-br from-slate to-card shadow-[0_0_60px_rgba(0,255,65,0.1),0_40px_80px_rgba(0,0,0,0.4)] overflow-hidden" data-id="element-233">
            <img src="https://cdn.magicpatterns.com/uploads/jNHhzG31udKgk2gLn2JBkN/ChatGPT_Image_9_mar_2026,_14_35_52.png" alt="The Unstoppable Brain Bundle Mockup" className="w-full h-full object-cover" data-id="element-234" />
          </div>
        </div>
      </div>
    </section>;
}